var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-container"},[_c('div',{staticClass:"spinner-container"},[(_vm.loading)?_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"loader"})]):_vm._e(),_c('div',{staticClass:"l-container__shared-route"},[_c('information-card'),_c('map-route'),_c('tours-details')],1),_c('enable-notifications'),_c('blocked-notifications')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }